import React, { useEffect, useState } from "react";
import {
 Box,
 Flex,
 Text,
 Image,
 VStack,
 Button,
 HStack,
 Checkbox,
 CheckboxGroup,
 useBreakpointValue,
 Icon,
 Heading,
 Collapse,
} from "@chakra-ui/react";
import { MdPlace } from "react-icons/md";
import { deemedUniversity } from "../collegesData/deemedUniversity";
import { useNavigate } from "react-router-dom";

const DeemedListingPage = () => {
 const navigate = useNavigate();
 const [selectedStates, setSelectedStates] = useState([]);
 const [showCourses, setShowCourses] = useState({});
 const [filterVisible, setFilterVisible] = useState(false);

 const allStates = [...new Set((deemedUniversity || []).map((c) => c.state))];
 const filteredColleges = selectedStates.length
  ? (deemedUniversity || []).filter((c) => selectedStates.includes(c.state))
  : deemedUniversity || [];

 const toggleCourses = (index) => {
  setShowCourses((prev) => ({ ...prev, [index]: !prev[index] }));
 };

 const isMobile = useBreakpointValue({ base: true, md: false });
 const handleNavigate = (university) => {
  navigate(`/d-details/${university.id}`, {
   state: {
    college: university,
   },
  });
 };

 return (
  <Flex direction={{ base: "column", md: "row" }}>
   <Box
    w={{ base: "100%", md: "250px" }}
    p={4}
    bg="gray.50"
    borderRight={{ md: "1px solid #e2e8f0" }}
    position={{ base: "relative", md: "fixed" }}
    top={{ md: "100px" }}
    left={0}
    height={{ base: "auto", md: "calc(100vh - 100px)" }}
    overflowY={{ md: "auto" }}
    zIndex={10}
    // mt={{ base: 0, md: 30 }}
   >
    <Flex justify="space-between" align="center" mb={4}>
     <Text fontSize="lg" fontWeight="bold">
      Filter by State
     </Text>
     {isMobile && (
      <Button
       size="sm"
       onClick={() => setFilterVisible(!filterVisible)}
       colorScheme="blue"
       variant="outline"
      >
       {filterVisible ? "Hide" : "Show"}
      </Button>
     )}
    </Flex>

    <Collapse in={!isMobile || filterVisible} animateOpacity>
     <CheckboxGroup
      colorScheme="blue"
      value={selectedStates}
      onChange={(val) => setSelectedStates(val)}
     >
      <VStack align="start" spacing={2}>
       {allStates.map((state) => (
        <Checkbox key={state} value={state}>
         {state}
        </Checkbox>
       ))}
      </VStack>
     </CheckboxGroup>
    </Collapse>
   </Box>

   <Box flex={1} p={4} ml={{ md: "250px" }}>
    <VStack spacing={6} p={4} align="stretch">
     <Box bg="white" boxShadow="lg" borderRadius="md" p={6}>
      <Heading as="h2" size="xl" textAlign="center" mb={4}>
       DEEMED MEDICAL COLLEGES IN INDIA 2025
      </Heading>
      <Text fontSize="md" textAlign="justify" color="gray.700">
       {/* summary text */}
      </Text>
     </Box>

     <Box bg="white" boxShadow="md" borderRadius="md" p={6} textAlign="center">
      <Heading as="h3" size="md" mb={2}>
       List of Deemed Medical Colleges 2025-26
      </Heading>
      <Text fontWeight="bold" fontSize="lg">
       STATEWISE LIST OF DEEMED MEDICAL INSTITUTION 2025
      </Text>
      <Text fontWeight="bold" mt={2}>
       Total Deemed Medical Colleges : 59, Total Seats : 11450
      </Text>
     </Box>
    </VStack>

    <Text fontSize="xl" mb={4}>
     {filteredColleges.length} Colleges Found
    </Text>

    <VStack spacing={4} align="stretch">
     {filteredColleges.map((university, index) => {
      const courses = university.courses || [];
      const maxCourses = 1;
      const showAllCourses = showCourses[index];
      const displayedCourses = showAllCourses
       ? courses
       : courses.slice(0, maxCourses);

      return (
       <Box
        key={index}
        display="flex"
        flexDirection={{ base: "column", lg: "row" }}
        alignItems="center"
        justifyContent="center"
        marginBottom="4vh"
        marginTop={4}
       >
        <Box
         border="2px solid #01B4EC"
         borderRadius="35px"
         overflow="hidden"
         p={4}
         bg="white"
         width={{ base: "90vw", md: "85vw", lg: "70vw" }}
         margin="auto"
         position="relative"
         fontFamily="Lato"
         cursor="pointer"
         boxShadow="rgba(0, 0, 0, 0.7) 5px 7px 8px"
         transition="transform 0.3s ease"
         _hover={{ transform: "translate(15px, 15px)" }}
        >
         <Flex direction={{ base: "column", md: "row" }} align="flex-start">
          <VStack align="center" justify="center" mb={{ base: 4, md: 0 }}>
           <Image
            src={university.image2 || "https://via.placeholder.com/150"}
            alt={university.collegename}
            boxSize="150px"
            objectFit="cover"
           />
          </VStack>

          <VStack
           width={{ base: "100%", md: "60%" }}
           textAlign="start"
           align="start"
           spacing={3}
           px={{ base: 0, md: 4 }}
          >
           <Text
            color="#01B4EC"
            fontSize={{ base: "0.9rem", lg: "1rem" }}
            fontWeight="bold"
           >
            {university.collegename}
           </Text>

           <Flex
            align="center"
            fontSize={{ base: "0.8rem", lg: "1rem" }}
            color="black"
            fontWeight="200"
            opacity="0.7"
           >
            <Icon as={MdPlace} boxSize={5} mr={1} />
            <Text>{university.address || "Unknown Address"},</Text>
            <Text ml={1}>{university.state}</Text>
           </Flex>

           <Box bg="gray.200" p={2} borderRadius="md" width="100%">
            <Text fontSize={{ base: "0.75rem", lg: "1rem" }}>
             <strong>Courses Offered:</strong>{" "}
             {displayedCourses
              .map((ele) => ele.name.replace("B.Tech ", ""))
              .join(", ")}
            </Text>

            {courses.length > maxCourses && (
             <Text
              fontSize="0.8rem"
              color="blue.500"
              cursor="pointer"
              mt={1}
              onClick={() => toggleCourses(index)}
             >
              {showAllCourses ? "See Less" : "See More"}
             </Text>
            )}

            <Box
             background="black"
             color="white"
             textAlign="start"
             p={1}
             mt={2}
            >
             <Text fontSize={{ base: "0.75rem", lg: "1rem" }}>
              <strong>Fees:</strong>{" "}
              {(() => {
               const matchedCourse = courses.find(
                (c) =>
                 c.name?.toLowerCase().includes("computer science") ||
                 c.name?.toLowerCase().includes("mbbs") ||
                 c.name?.toLowerCase().includes("b.tech")
               );
               if (!matchedCourse) return "N/A";
               if (typeof matchedCourse.fees === "object") {
                return matchedCourse.fees.inr || "N/A";
               }
               return matchedCourse.fees || "N/A";
              })()}
             </Text>
            </Box>
           </Box>
          </VStack>

          <VStack align="end" mt={{ base: 4, md: 0 }}>
           <Button
            width={{ base: "100%", md: "10vw" }}
            fontSize={{ base: "0.7rem", lg: "1rem" }}
            borderRadius="10px"
            height="4vh"
            border="2px solid #01B4EC"
            cursor="pointer"
            onClick={() => handleNavigate(university)}
            _hover={{ backgroundColor: "#01B4EC", color: "white" }}
           >
            Details
           </Button>
          </VStack>
         </Flex>

         <HStack mt={4} fontSize={{ base: "0.7rem", lg: "1rem" }}>
          <Flex wrap="wrap" gap={2}>
           {["About", "Courses", "Cut Off", "Admission", "Qna"].map(
            (item, idx) => (
             <React.Fragment key={idx}>
              <Text>{item}</Text>
              {idx < 4 && <Box w="2px" h="1.3rem" bg="black" />}
             </React.Fragment>
            )
           )}
          </Flex>
         </HStack>
        </Box>
       </Box>
      );
     })}
    </VStack>
   </Box>
  </Flex>
 );
};

export default DeemedListingPage;

// import React, { useEffect, useState } from "react";
// import {
//  Box,
//  Flex,
//  Text,
//  Image,
//  VStack,
//  Button,
//  HStack,
//  Checkbox,
//  CheckboxGroup,
//  useBreakpointValue,
//  Icon,
//  Heading,
//  Collapse,
// } from "@chakra-ui/react";
// import { MdPlace } from "react-icons/md";
// import { deemedUniversity } from "../collegesData/deemedUniversity";
// import { useNavigate } from "react-router-dom";

// const DeemedListingPage = () => {
//  const navigate = useNavigate();
//  const [selectedStates, setSelectedStates] = useState([]);
//  const [showCourses, setShowCourses] = useState({});
//  const [filterVisible, setFilterVisible] = useState(false);

//  const allStates = [...new Set((deemedUniversity || []).map((c) => c.state))];
//  const filteredColleges = selectedStates.length
//   ? (deemedUniversity || []).filter((c) => selectedStates.includes(c.state))
//   : deemedUniversity || [];

//  const toggleCourses = (index) => {
//   setShowCourses((prev) => ({ ...prev, [index]: !prev[index] }));
//  };

//  const isMobile = useBreakpointValue({ base: true, md: false });
//  const handleNavigate = (university) => {
//   console.log("university:", university);
//   navigate(`/d-details/${university.id}`, {
//    state: {
//     college: university, // send PDF URL
//    },
//   });
//  };

//  return (
//   <Flex direction={{ base: "column", md: "row" }}>
//    <Box
//     w={{ base: "100%", md: "250px" }}
//     p={4}
//     bg="gray.50"
//     borderRight={{ md: "1px solid #e2e8f0" }}
//     position="fixed"
//     top={{ base: "auto", md: "100px" }}
//     left={0}
//     height="calc(100vh - 100px)"
//     overflowY="auto"
//     zIndex={10}
//     mt={30}
//    >
//     <Flex justify="space-between" align="center" mb={4}>
//      <Text fontSize="lg" fontWeight="bold">
//       Filter by State
//      </Text>
//      {isMobile && (
//       <Button
//        size="sm"
//        onClick={() => setFilterVisible(!filterVisible)}
//        colorScheme="blue"
//        variant="outline"
//       >
//        {filterVisible ? "Hide" : "Show"}
//       </Button>
//      )}
//     </Flex>

//     <Collapse in={!isMobile || filterVisible} animateOpacity>
//      <CheckboxGroup
//       colorScheme="blue"
//       value={selectedStates}
//       onChange={(val) => setSelectedStates(val)}
//      >
//       <VStack align="start" spacing={2}>
//        {allStates.map((state) => (
//         <Checkbox key={state} value={state}>
//          {state}
//         </Checkbox>
//        ))}
//       </VStack>
//      </CheckboxGroup>
//     </Collapse>
//    </Box>

//    <Box flex={1} p={4} ml={{ md: "250px" }} mt={{ base: 4, md: 160 }}>
//     <VStack spacing={6} p={6} align="stretch">
//      <Box
//       bg="white"
//       boxShadow="lg"
//       borderRadius="md"
//       p={6}
//       maxW="6xl"
//       mx="auto"
//      >
//       <Heading as="h2" size="xl" textAlign="center" mb={4}>
//        DEEMED MEDICAL COLLEGES IN INDIA 2025
//       </Heading>
//       <Text fontSize="md" textAlign="justify" color="gray.700">
//        In India there are total 59 Deemed Medical Colleges accepting NEET UG and
//        offering MBBS Course as on August 2025, Andhra Pradesh, Delhi, Gujarat,
//        Jharkhand, Kerala, Uttarakhand and Uttar Pradesh states have one deemed
//        Medical Colleges in each state, Odisha, Telangana and Haryana have two
//        Deemed Medical Colleges, Pondicherry have four Deemed Medical Colleges,
//        Tamil Nadu have 14 Deemed Medical Colleges, Karnataka have 12 Deemed
//        Medical Colleges and Maharashtra have 14 Deemed Medical Colleges. The
//        Karnataka, Maharashtra, Tamil Nadu and Pondicherry states having highest
//        number of Deemed Medical Colleges 14, 12, 14 and 5 respectively. The Best
//        and Top Deemed Medical Colleges in India as follows: Kasturba Medical
//        College, Manipal, Karnataka, Kasturba Medical College, Mangalore ,
//        Karnataka, Sri Ramachandra Medical College & Research Institute, Chennai,
//        Tamil Nadu, Jawaharlal Nehru Medical College,(KLE University) ,Belgaum,
//        Karnataka, JSS Medical college, Mysore, Karnataka, Symbiosis Medical
//        College for Women, Pune (For Women)-Maharashtra, Rural Medical College,
//        Loni, (Pravara Institute of Medical Sciences)-Maharashtra, Bharati
//        Vidyapeeth University Medical College, Pune- Maharashtra, Padmashri Dr. D
//        Y Patil Medical College, Pimpri, Pune, Maharashtra. In India total 11450
//        MBBS Seats available in all 59 Deemed Medical Colleges.
//       </Text>
//      </Box>

//      <Box
//       bg="white"
//       boxShadow="md"
//       borderRadius="md"
//       p={6}
//       maxW="6xl"
//       mx="auto"
//       textAlign="center"
//      >
//       <Heading as="h3" size="md" mb={2}>
//        List of Deemed Medical Colleges 2025-26
//       </Heading>
//       <Text fontWeight="bold" fontSize="lg">
//        STATEWISE LIST OF DEEMED MEDICAL INSTITUTION 2025
//       </Text>
//       <Text fontWeight="bold" mt={2}>
//        Total Deemed Medical Colleges : 59, Total Seats : 11450
//       </Text>
//      </Box>
//     </VStack>
//     <Text fontSize="xl" mb={4}>
//      {filteredColleges.length} Colleges Found
//     </Text>
//     <VStack spacing={4} align="stretch">
//      {filteredColleges.map((university, index) => {
//       const courses = university.courses || [];
//       const maxCourses = 1;
//       const showAllCourses = showCourses[index];
//       const displayedCourses = showAllCourses
//        ? courses
//        : courses.slice(0, maxCourses);

//       return (
//        <Box
//         key={index}
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         marginBottom="4vh"
//         marginLeft={{ lg: "1vw" }}
//         marginTop={4}
//        >
//         {index}
//         <Box
//          border="2px solid #01B4EC"
//          borderRadius="35px"
//          overflow="hidden"
//          p={4}
//          bg="white"
//          width={{ base: "100vw", lg: "70vw" }}
//          margin="auto"
//          position="relative"
//          fontFamily="Lato"
//          cursor="pointer"
//          boxShadow="rgba(0, 0, 0, 0.7) 5px 7px 8px"
//          transition="transform 0.3s ease"
//          _hover={{ transform: "translate(15px, 15px)" }}
//         >
//          <HStack align="start">
//           <VStack ml={{ base: "1vw", lg: "3vw" }}>
//            <Image
//             src={university.image2 || "https://via.placeholder.com/150"}
//             alt={university.collegename}
//             boxSize="150px"
//             objectFit="cover"
//            />
//           </VStack>

//           <VStack width="45vw" textAlign="center" align="start" spacing={3}>
//            <Text
//             color="#01B4EC"
//             fontSize={{ base: "0.8rem", lg: "1rem" }}
//             fontWeight="bold"
//            >
//             {university.collegename}
//            </Text>

//            <Flex
//             align="center"
//             fontSize={{ base: "0.7rem", lg: "1rem" }}
//             color="black"
//             fontWeight="200"
//             opacity="0.7"
//            >
//             <Icon as={MdPlace} boxSize={5} mr={1} />
//             <Text>{university.address || "Unknown Address"},</Text>
//             <Text ml={1}>{university.state}</Text>
//            </Flex>

//            <Box bg="gray.200" p={2} borderRadius="md" width="100%">
//             <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
//              <strong>Courses Offered:</strong>{" "}
//              {displayedCourses
//               .map((ele) => ele.name.replace("B.Tech ", ""))
//               .join(", ")}
//             </Text>

//             {courses.length > maxCourses && (
//              <Text
//               fontSize="0.7rem"
//               color="blue.500"
//               cursor="pointer"
//               mt={1}
//               onClick={() => toggleCourses(index)}
//              >
//               {showAllCourses ? "See Less" : "See More"}
//              </Text>
//             )}

//             <Box
//              background="black"
//              color="white"
//              textAlign="start"
//              p={1}
//              mt={2}
//             >
//              <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
//               <strong>Fees:</strong>{" "}
//               {(() => {
//                const matchedCourse = courses.find(
//                 (c) =>
//                  c.name?.toLowerCase().includes("computer science") ||
//                  c.name?.toLowerCase().includes("mbbs") ||
//                  c.name?.toLowerCase().includes("b.tech")
//                );
//                if (!matchedCourse) return "N/A";

//                if (typeof matchedCourse.fees === "object") {
//                 return matchedCourse.fees.inr || "N/A"; // 🛡️ Safely access INR fee
//                }
//                return matchedCourse.fees || "N/A"; // If still a string fallback
//               })()}
//              </Text>
//             </Box>
//            </Box>
//           </VStack>

//           <VStack align="end">
//            <Button
//             width="10vw"
//             fontSize={{ base: "0.6rem", lg: "1rem" }}
//             borderRadius="10px"
//             height="4vh"
//             mt={4}
//             border="2px solid #01B4EC"
//             cursor="pointer"
//             onClick={() => handleNavigate(university)}
//             _hover={{ backgroundColor: "#01B4EC", color: "white" }}
//            >
//             Details
//            </Button>
//           </VStack>
//          </HStack>

//          <HStack mt={4} fontSize={{ base: "0.6rem", lg: "1rem" }}>
//           <Flex>
//            {["About", "Courses", "Cut Off", "Admission", "Qna"].map(
//             (item, idx) => (
//              <React.Fragment key={idx}>
//               <Text mx={3}>{item}</Text>
//               {idx < 4 && <Box w="2px" h="1.3rem" bg="black" />}
//              </React.Fragment>
//             )
//            )}
//           </Flex>
//          </HStack>
//         </Box>
//        </Box>
//       );
//      })}
//     </VStack>
//    </Box>
//   </Flex>
//  );
// };

// export default DeemedListingPage;
